const ID_COMPONENTE = {
  DOCAS: 6,
}

export default ID_COMPONENTE
